import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { ambientesService, type DadosAmbiente } from "@/modules/reservas/services/ambientesService";

const QUERY_KEY_AMBIENTES = ["ambientes"];

export function useAmbientes() {
  return useQuery({ queryKey: QUERY_KEY_AMBIENTES, queryFn: ambientesService.listar });
}

export function useAmbientesAtivos() {
  return useQuery({
    queryKey: [...QUERY_KEY_AMBIENTES, "ativos"],
    queryFn: ambientesService.listarAtivos,
  });
}

export function useCriarAmbiente() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (dados: DadosAmbiente) => ambientesService.criar(dados),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: QUERY_KEY_AMBIENTES }),
  });
}

export function useAtualizarAmbiente() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, dados }: { id: string; dados: DadosAmbiente }) =>
      ambientesService.atualizar(id, dados),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: QUERY_KEY_AMBIENTES }),
  });
}

export function useExcluirAmbiente() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => ambientesService.excluir(id),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: QUERY_KEY_AMBIENTES }),
  });
}
